// extracted by mini-css-extract-plugin
export default {"gridDiv":"womenPage_gridDiv__e-hiT","flexDiv":"womenPage_flexDiv__ysNnt","desc":"womenPage_desc__gz+fK"};